const ATTRIBUTION_PARAM_KEYS = [
  'gclid',
  'fbclid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'utm_id',
] as const;

type AttributionKey = (typeof ATTRIBUTION_PARAM_KEYS)[number];
type AttributionParams = Partial<Record<AttributionKey, string>>;

export function parseAttributionParams(search: string): AttributionParams {
  const params = new URLSearchParams(search);
  const result: AttributionParams = {};
  for (const key of ATTRIBUTION_PARAM_KEYS) {
    const value = params.get(key);
    if (value) result[key] = value;
  }
  return result;
}

const CLICK_ID_KEYS = ['gclid', 'fbclid'] as const;

function toInitialPeopleProps(attribution: AttributionParams): Record<string, string> | undefined {
  const props: Record<string, string> = {};
  for (const key of CLICK_ID_KEYS) {
    if (attribution[key]) props[`initial_${key}`] = attribution[key];
  }
  return Object.keys(props).length > 0 ? props : undefined;
}

const STORAGE_KEY = 'svq_attribution';

export function captureAttribution(search: string): void {
  try {
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    const eventProps = parseAttributionParams(search);
    if (Object.keys(eventProps).length === 0) return;

    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ eventProps, initialPeopleProps: toInitialPeopleProps(eventProps) }),
    );
  } catch (error) {
    void error;
  }
}
